let resourceType = localStorage.resource_type
let redirectUrlDefault = null
if(resourceType === 'Staff' || resourceType === 'Manager') {
  redirectUrlDefault = '/agents/houses'
}

export default redirectUrlDefault
